var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chartist',{staticClass:"ct-chart",attrs:{"type":"Line","id":"chart1"}},[_c('strong',[_vm._v("Elevation Profile")])])}
var staticRenderFns = []

export { render, staticRenderFns }